<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldOrderLink',
  components: {
    BaseField,
  },
  computed: {
    attributes() {
      return {
        type: 'number',
        placeholder: this.$t('fields.orderLink'),
        errorMessage: this.$t('fields.badOrderLink'),
        maskOptions: {
          mask: Number,
        },
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    focus() {
      return this.$refs.field?.focus();
    },
  },
};
</script>
